import './PortfolioStyle.css';
import { FiExternalLink } from "react-icons/fi";
import francinajaumandreu from '../../images/francinajaumandreu.jpg';
import mouteperbarcelona from '../../images/mouteperbarcelona.png';
import sneakeracademy from '../../images/barcelonasneakersacademy.png';
import inmedia from '../../images/inmedia.jpg';
import magnificPlace from '../../images/maginificPlace.jpg';
import acfae from '../../images/acfae.jpg';
import agenciaSetting from '../../images/agenciaSetting.jpg';
import managersLab from '../../images/managersLab.jpg';
import centralParc from '../../images/centralParc.jpg';
import tecnicasFerreres from '../../images/tecnicasFerreres.jpg';
import ecoSerra from '../../images/ecoSerra.png';
import museuCinema from '../../images/MuseuCinema.png';

function Portfolio() {
    return (
        <main>
            <div className='portfolio-contenedor'>
                <div className='portfolio-titulo'>
                    <h3>Portfolio</h3>
                </div>
                <div className='portfolio-grid'>
                    <div className='portfolio-item'>
                        <div className='portfolio-item-screen'>
                            <a target="_blank" href="https://francinajaumandreu.com/" rel="nofollow noreferrer">
                                <img src={francinajaumandreu} alt="Francina Jaumandreu Celebrant de funerals" />
                            </a>
                        </div>
                        <div className='portfolio-item-content'>
                            <h4><a target="_blank" href="https://francinajaumandreu.com/" rel="nofollow noreferrer">
                                Francinajaumandreu.com <FiExternalLink />
                            </a></h4>
                            <p>Web corporativa. Diseño y desarrollo de web completa a partir de la imagen corporativa y textos entregados por el cliente.</p>
                            <div className='stack-tech-portfolio'>
                                <ul>
                                    <li><div>HTML + CSS</div></li>
                                    <li><div>JavaScript</div></li>
                                    <li><div>WordPress</div></li>
                                    <li><div>Elementor</div></li>
                                    <li><div>Desarrollo plugin</div></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='portfolio-item'>
                        <div className='portfolio-item-screen'>
                            <a target="_blank" href="https://mouteperbarcelona.com/" rel="nofollow noreferrer">
                                <img src={mouteperbarcelona} alt="Mou-te per Barcelona" />
                            </a>
                        </div>
                        <div className='portfolio-item-content'>
                            <h4><a target="_blank" href="https://mouteperbarcelona.com/" rel="nofollow noreferrer">
                                Mouteperbarcelona.com <FiExternalLink />
                            </a></h4>
                            <p>Asociación de entidades y empresa comprometidas con la mejora de la movilidad en Barcelona y su entorno. Diseño y desarrollo de una web onpeage.</p>
                            <div className='stack-tech-portfolio'>
                                <ul>
                                    <li><div>HTML + CSS</div></li>
                                    <li><div>JavaScript</div></li>
                                    <li><div>WordPress</div></li>
                                    <li><div>Elementor</div></li>
                                    <li><div>Desarrollo plugin</div></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='portfolio-item'>
                        <div className='portfolio-item-screen'>
                            <a target="_blank" href="https://barcelonasneakersacademy.com/" rel="nofollow noreferrer">
                                <img src={sneakeracademy} alt="Barcelona sneakers academy" />
                            </a>
                        </div>
                        <div className='portfolio-item-content'>
                            <h4><a target="_blank" href="https://barcelonasneakersacademy.com/" rel="nofollow noreferrer">
                                Barcelonasneakersacademy.com <FiExternalLink />
                            </a></h4>
                            <p>La primera academia de sneakers en España. Desarrollo y maquetación web del diseño entregado por el cliente.</p>
                            <div className='stack-tech-portfolio'>
                                <ul>
                                    <li><div>HTML</div></li>
                                    <li><div>CSS</div></li>
                                    <li><div>JavaScript</div></li>
                                    <li><div>WordPress</div></li>
                                    <li><div>Elementor</div></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='portfolio-item'>
                        <div className='portfolio-item-screen'>
                            <a target="_blank" href="https://inmedia.es/" rel="nofollow noreferrer">
                                <img src={inmedia} alt="Inmedia Solutions" />
                            </a>
                        </div>
                        <div className='portfolio-item-content'>
                            <h4><a target="_blank" href="https://inmedia.es/" rel="nofollow noreferrer">Inmedia.es <FiExternalLink /></a></h4>
                            <p>Consultoria de comunicación especializada en Turismo. Desarrollé el sitio completo a partir de los esquemas y contenidos que entregó el cliente.</p>
                            <div className='stack-tech-portfolio'>
                                <ul>
                                    <li><div>HTML</div></li>
                                    <li><div>CSS</div></li>
                                    <li><div>JavaScript</div></li>
                                    <li><div>Diseño</div></li>
                                    <li><div>WordPress</div></li>
                                    <li><div>Elementor</div></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='portfolio-item'>
                        <div className='portfolio-item-screen'>
                            <a target="_blank" href="https://agenciasetting.com/" rel="nofollow noreferrer">
                                <img src={agenciaSetting} alt="Agència Setting" />
                            </a>
                        </div>
                        <div className='portfolio-item-content'>
                            <h4><a target="_blank" href="https://agenciasetting.com/" rel="nofollow noreferrer">Agenciasetting.com <FiExternalLink /></a></h4>
                            <p>Agencia de comunicación. Diseño y desarrollo de la web a partir de los textos y los objetivos del cliente.</p>
                            <div className='stack-tech-portfolio'>
                                <ul>
                                    <li><div>HTML</div></li>
                                    <li><div>CSS</div></li>
                                    <li><div>Diseño</div></li>
                                    <li><div>WordPress</div></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='portfolio-item'>
                        <div className='portfolio-item-screen'>
                            <a target="_blank" href="https://www.acfae.es/" rel="nofollow noreferrer">
                                <img src={acfae} alt="ACFAE" />
                            </a>
                        </div>
                        <div className='portfolio-item-content'>
                            <h4><a target="_blank" href="https://www.acfae.es/" rel="nofollow noreferrer">Acfae.es <FiExternalLink /></a></h4>
                            <p>Asociación de Comerciantes de Fuegos Artificiales de España. Diseño y desarrollo de una nueva web con el objetivo de modernizar su presencia online.</p>
                            <div className='stack-tech-portfolio'>
                                <ul>
                                    <li><div>HTML</div></li>
                                    <li><div>CSS</div></li>
                                    <li><div>Diseño</div></li>
                                    <li><div>WordPress</div></li>
                                    <li><div>Elementor</div></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='portfolio-item'>
                        <div className='portfolio-item-screen'>
                            <a target="_blank" href="https://magnificplace.com/" rel="nofollow noreferrer">
                                <img src={magnificPlace} alt="Magnific Place" />
                            </a>
                        </div>
                        <div className='portfolio-item-content'>
                            <h4><a target="_blank" href="https://magnificplace.com/" rel="nofollow noreferrer">Magnificplace.com <FiExternalLink /></a></h4>
                            <p>Plataforma de promoción de áreas comerciales. El cliente quería mostrar su propuesta de una forma clara y sencilla. Creé esta web onepage a partir de los textos e imágenes entregados.</p>
                            <div className='stack-tech-portfolio'>
                                <ul>
                                    <li><div>HTML</div></li>
                                    <li><div>CSS</div></li>
                                    <li><div>Diseño</div></li>
                                    <li><div>WordPress</div></li>
                                    <li><div>Elementor</div></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className='portfolio-item'>
                        <div className='portfolio-item-screen'>
                            <a target="_blank" href="https://centralparc.cat/" rel="nofollow noreferrer">
                                <img src={centralParc} alt="Central Parc" />
                            </a>
                        </div>
                        <div className='portfolio-item-content'>
                            <h4><a target="_blank" href="https://centralparc.cat/" rel="nofollow noreferrer">Centralparc.cat <FiExternalLink /></a></h4>
                            <p>Cooperativa agraria. Diseño y desarrollo web a partir de los objetivos del cliente.</p>
                            <div className='stack-tech-portfolio'>
                                <ul>
                                    <li><div>HTML</div></li>
                                    <li><div>CSS</div></li>
                                    <li><div>Diseño</div></li>
                                    <li><div>WordPress</div></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='portfolio-item'>
                        <div className='portfolio-item-screen'>
                            <a target="_blank" href="https://tecnicasferreres.es/" rel="nofollow noreferrer">
                                <img src={tecnicasFerreres} alt="Tecnicas Ferreres" />
                            </a>
                        </div>
                        <div className='portfolio-item-content'>
                            <h4><a target="_blank" href="https://tecnicasferreres.es/" rel="nofollow noreferrer">Tecnicasferreres.es <FiExternalLink /></a></h4>
                            <p>Empresa distribuidora de productos industriales. Desarrollo de la web a partir del diseño entregado por el cliente.</p>
                            <div className='stack-tech-portfolio'>
                                <ul>
                                    <li><div>HTML</div></li>
                                    <li><div>CSS</div></li>
                                    <li><div>WordPress</div></li>
                                    <li><div>Elementor</div></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default Portfolio;